<div mat-dialog-title>
    {{ data.title }}
</div>
<div mat-dialog-content qa="dialogue-text">
    {{ data.message }}
</div>
<div mat-dialog-actions>
    <button
        class="dialog-btn"
        qa="dialog-btn"
        mat-raised-button
        (click)="close()"
        color="primary"
    >
        Ok
    </button>
</div>
